import { AddressViewModel, AffinityDelivery, AffinityProduct, HarrierPricingItemModel, HarrierPricingModel, LastPurchased, PlaceOrderStep, PriceOptionViewModel, ProductModelX, ProductViewModel, QuantityViewModel } from "@affinity/Store/StoreTypes";
import { Category } from "@insite/client-framework/Services/CategoryService";
import { ProductModel, ProductPriceDto, ShipToCollectionModel, ShipToModel } from "@insite/client-framework/Types/ApiModels";

export type PlaceOrderState = Readonly<{
    currentStep: PlaceOrderStep;
    productRegular: ProductModel | undefined;
    productPremium: ProductModel | undefined;
    quantityRegular: QuantityViewModel | undefined;
    quantityPremium: QuantityViewModel | undefined;
    deliveryCheapest: PriceOptionViewModel | undefined;
    deliverySoonest: PriceOptionViewModel | undefined;
    stepValues: Record<PlaceOrderStep, string | undefined> | undefined;
    hasAttemped: Boolean;

    // NEW
    existingAddresses: ShipToCollectionModel | undefined;
    selectedAddress: ShipToModel | undefined;
    selectedProduct: AffinityProduct;
    allowMarketing: boolean;
    selectedDelivery: AffinityDelivery;
    isInitialised: boolean;
    isAddingAddress: boolean;
    phone: string | undefined,
    pricingRaw: HarrierPricingModel | undefined,
    pricingSelected: HarrierPricingItemModel | undefined,

    quantity: number | undefined;
    quantityDescription: string | undefined; // For Quantity: <quantity> litres
    shipToId: string | undefined;
    shipToDescription: string | undefined; // For Delivery address: <address>
    shipToModel: ShipToModel | undefined;
    shipToRaw: ShipToModel[] | undefined;
    shipToMapped: AddressViewModel[] | undefined;
    priceAndDelivery: AffinityDelivery | undefined;
    priceAndDeliveryOptionId: string | undefined; // MODEL TBD MAKE NEW ONE
    priceAndDeliveryDescription: string | undefined; // For Price and delivery option: <quantity> litres @ <price> by <date> (<total price> ex VAT)
    priceOptionsRaw: ProductPriceDto[] | undefined;
    priceOptionsMapped: PriceOptionViewModel[] | undefined;
    deliveryInstructions: string | undefined; // For Delivery instructions: <data>
    purchaseOrder: string | undefined;
    completedRedirectUrl: string | undefined;
    viewModelQuantity: QuantityViewModel | undefined;
    targetUrl: string | undefined;
}>;

export const initialState: PlaceOrderState = {
    currentStep: PlaceOrderStep.SelectProduct,
    productRegular: undefined,
    productPremium: undefined,
    quantityRegular: undefined,
    quantityPremium: undefined,
    stepValues: undefined,
    deliveryCheapest: undefined,
    deliverySoonest: undefined,
    hasAttemped: false,

    // NEW
    existingAddresses: undefined,
    selectedAddress: undefined,
    selectedProduct: AffinityProduct.Regular,
    allowMarketing: false,
    selectedDelivery: AffinityDelivery.Cheapest,
    isInitialised: false,
    isAddingAddress: false,
    phone: undefined,
    pricingRaw: undefined,
    pricingSelected: undefined,

    quantity: undefined,
    quantityDescription: undefined,
    shipToId: undefined,
    shipToDescription: undefined,
    shipToModel: undefined,
    shipToRaw: undefined,
    shipToMapped: undefined,
    priceAndDelivery: undefined,
    priceAndDeliveryOptionId: undefined,
    priceAndDeliveryDescription: undefined,
    priceOptionsRaw: undefined,
    priceOptionsMapped: undefined,
    deliveryInstructions: undefined,
    purchaseOrder: undefined,
    completedRedirectUrl: "/Cart",
    viewModelQuantity: undefined,
    targetUrl: undefined,
};

export default PlaceOrderState;